/**
 * Revisar enlace para para mas keyworks
 * https://github.com/ag-grid/ag-grid/blob/latest/community-modules/locale/src/es-ES.ts
 * 
 * Si se rompe la app porque no encuentra alguna de estas keywords, probablemente
 * actualizaste la version de ag-grid-angular/ag-grid-community o.O
 * y ahora tienen otro nombre
 */

export const localeEs = {
  applyFilter: 'Aplicar filtro',
  clearFilter: 'Limpiar filtro',
  resetFilter: 'Restablecer filtro',
  cancelFilter: 'Cancelar filtro',
  textFilter: 'Filtro de texto',
  numberFilter: 'Filtro numérico',
  contains: 'Contiene',
  notContains: 'No contiene',
  equals: 'Igual a',
  notEqual: 'Distinto a',
  startsWith: 'Empieza con',
  endsWith: 'Termina con',
  blank: 'Vacío',
  notBlank: 'No vacío',
  andCondition: 'Y',
  orCondition: 'O',
  filterOoo: 'Filtrar...'
};
